import React from "react";

const CompanyProfile = () => {
  return (
    <div style={{ backgroundColor: "", height: "100vh", width: "100vw" }}>
      Company Profile
    </div>
  );
};

export default CompanyProfile;
